function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#E5E5E5"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 1512,
  height: 982,
  transform: "translate(-198 -730)",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: -198,
  y: -730,
  width: 1512,
  height: 982,
  fill: "#100B00"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: -12,
  y: -105,
  width: 273,
  height: 218,
  rx: 16,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_129_1431)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 273,
  height: 56,
  transform: "translate(-12 -16)",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0001 22.75H9.00014C7.68014 22.75 6.58015 22.62 5.65015 22.34C5.31015 22.24 5.09015 21.91 5.11015 21.56C5.36015 18.57 8.39015 16.22 12.0001 16.22C15.6101 16.22 18.6301 18.56 18.8901 21.56C18.9201 21.92 18.7001 22.24 18.3501 22.34C17.4201 22.62 16.3201 22.75 15.0001 22.75ZM6.72015 21.06C7.38015 21.19 8.13014 21.25 9.00014 21.25H15.0001C15.8701 21.25 16.6201 21.19 17.2801 21.06C16.7501 19.14 14.5601 17.72 12.0001 17.72C9.44015 17.72 7.25015 19.14 6.72015 21.06Z",
  fill: "#100B00"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 16.9506 22.4585 18.5641 21.7401 19.8128C21.0039 21.0923 19.8645 21.9113 18.3443 22.3416C18.1288 22.4026 17.8974 22.3642 17.7133 22.2368C17.5291 22.1094 17.4115 21.9063 17.3927 21.6832C17.2156 19.5909 14.9928 17.72 12 17.72C9.00719 17.72 6.78438 19.5909 6.60733 21.6832C6.58845 21.9063 6.47087 22.1094 6.28673 22.2368C6.10259 22.3642 5.87116 22.4026 5.65571 22.3416C4.13552 21.9113 2.99613 21.0923 2.25993 19.8128C1.54148 18.5641 1.25 16.9506 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467ZM4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 16.8294 3.02852 18.1409 3.56007 19.0647C3.95322 19.748 4.50844 20.2603 5.28506 20.6155C6.02949 18.0088 8.85826 16.22 12 16.22C15.1417 16.22 17.9705 18.0088 18.7149 20.6155C19.4916 20.2603 20.0468 19.748 20.4399 19.0647C20.9715 18.1409 21.25 16.8294 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533ZM12 7.75C10.4342 7.75 9.17 9.01423 9.17 10.58C9.17 12.1485 10.4369 13.42 12 13.42C13.5631 13.42 14.83 12.1485 14.83 10.58C14.83 9.01423 13.5658 7.75 12 7.75ZM7.67 10.58C7.67 8.18581 9.60578 6.25 12 6.25C14.3942 6.25 16.33 8.18581 16.33 10.58C16.33 12.9715 14.3969 14.92 12 14.92C9.60307 14.92 7.67 12.9715 7.67 10.58Z",
  fill: "#100B00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 14.92C9.60992 14.92 7.66992 12.97 7.66992 10.58C7.66992 8.19002 9.60992 6.25 11.9999 6.25C14.3899 6.25 16.3299 8.19002 16.3299 10.58C16.3299 12.97 14.3899 14.92 11.9999 14.92ZM11.9999 7.75C10.4399 7.75 9.16992 9.02002 9.16992 10.58C9.16992 12.15 10.4399 13.42 11.9999 13.42C13.5599 13.42 14.8299 12.15 14.8299 10.58C14.8299 9.02002 13.5599 7.75 11.9999 7.75Z",
  fill: "#100B00"
}));

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_129_1431",
  x: -12,
  y: -16,
  width: 273,
  height: 57,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_129_1431"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_129_1431",
  result: "shape"
})));

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8e80740b.svg";
export { ForwardRef as ReactComponent };